module.exports = __webpack_public_path__ + "static/img/jiaoyu.418311b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiaoyu.jpg
// module id = x3T8
// module chunks = 0